// extracted by mini-css-extract-plugin
module.exports = {"description":"JobsFAQBlock-module--description--38i8R","section":"JobsFAQBlock-module--section--2LyRe","title":"JobsFAQBlock-module--title--MOfbV"};